import type { HomeLayout } from './types';

// Delete a widget from the layout entirely. (Grouping was removed; widgets are a
// flat, free-placed list.)
export function removeWidget(layout: HomeLayout, widgetId: string): HomeLayout {
  return { ...layout, widgets: layout.widgets.filter((w) => w.id !== widgetId) };
}
